import React, { ReactElement, FC } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { ISearchTagsResponse } from '../../redux/api/loadTags/loadTags.model';
import { LoadLocation } from '../../redux/api/load/load.model';
import './TwLoadTooltipInfo.scss';
import { TRIP_STATUS } from '../../redux/api/trips/trips.model';
import { BOOKING_TYPE, ORDER_STATUS } from '../../redux/api/orders/orders.model';

export interface TwLoadTooltipInfoProps {
  tags: ISearchTagsResponse[];
  loadStatus: ORDER_STATUS;
  loadId: string;
  clientName: string;
  rate: number | null;
  ratePerMile?: number | null;
  customerOrderNumber?: string | number | null;
  pickupLocation: LoadLocation | null;
  deliveryLocation: LoadLocation | null;
  stops?: string | number;
  pickupDate?: string;
  pickupStartTime?: string;
  pickupEndTime?: string;
  deliveryDate?: string;
  deliveryStartTime?: string;
  deliveryEndTime?: string;
  loadReadableId: number;
  brokered: boolean;
  pickupNumber?: string;
  deliveryNumber?: string;
  booking_type?: BOOKING_TYPE;
}

export interface TwTripTooltipInfoProps {
  tags: ISearchTagsResponse[];
  tripStatus: TRIP_STATUS;
  tripId?: string;
  tripReadableId?: string | number;
  loadId: string;
  clientName: string;
  pickupLocation?: LoadLocation | null;
  deliveryLocation?: LoadLocation | null;
  stops?: string | number;
  pickupDate?: string;
  pickupStartTime?: string;
  pickupEndTime?: string;
  deliveryDate?: string;
  deliveryStartTime?: string;
  deliveryEndTime?: string;
  unassigned: boolean;
  loadReadableId: number | string;
  pickupNumber?: string;
  deliveryNumber?: string;
  segmentsCount?: number;
  order: number;
  driverName?: string;
  truckName?: string;
  trailerName?: string;
}

export interface TwLoadTooltipContentProps {
  tooltipContent: ReactElement;
  children?: ReactElement;
}

const TwLoadTooltipInfo: FC<TwLoadTooltipContentProps> = ({
  tooltipContent,
  children
}): JSX.Element => {
  return (
    <Tooltip
      classes={{
        tooltip: 'tw-load-tooltip',
        arrow: 'tw-load-tooltip__arrow'
      }}
      placement="bottom-start"
      title={tooltipContent}
      arrow
    >
      {children !== undefined ? children : <></>}
    </Tooltip>
  );
};

export default TwLoadTooltipInfo;
